// extracted by mini-css-extract-plugin
export default {"create-job-throttling-modal":"styles_create-job-throttling-modal__BFcTU","createJobThrottlingModal":"styles_create-job-throttling-modal__BFcTU"};